import React from 'react';
import PropTypes from 'prop-types';
import logger from '~/services/logger';
import analytics from '~/services/analytics';
import usePageTrack from '~/services/analytics/usePageTrack';
import StreamYardVsCompetitorTemplate from '../StreamYardVsCompetitorTemplate';
import ParticularFeatureInstructionsTemplate from '../ParticularFeatureInstructionsTemplate';

const templateRegistry = {
	'competitor-comparison': StreamYardVsCompetitorTemplate,
	'particular-feature-instructions': ParticularFeatureInstructionsTemplate,
};

const JsonLandingPageTemplate = ({ data }) => {
	const TemplateComponent = templateRegistry[data.template];
	usePageTrack({
		name: data.metadata.slug,
		category: analytics.events.category.MARKETING,
	});

	if (!TemplateComponent) {
		logger.error('Template not found', { template: data.template });
		return null;
	}

	return <TemplateComponent data={data} />;
};

JsonLandingPageTemplate.propTypes = {
	data: PropTypes.shape({
		template: PropTypes.string.isRequired,
		version: PropTypes.string.isRequired,
		metadata: PropTypes.shape({
			slug: PropTypes.string.isRequired,
			translationNamespace: PropTypes.string.isRequired,
		}).isRequired,
		content: PropTypes.object.isRequired,
	}).isRequired,
};

export default JsonLandingPageTemplate;
